<script lang="ts">
import {defineComponent} from "vue"
import Menubar from "primevue/menubar"
import {useThemeStore} from "@/stores/theme.store"
import {useAuthStore} from "@/stores/auth.store"
import Button from "primevue/button"
import {fetchWrapper} from "@/helpers/fetchWrapper";
import backendRoutes from "@/backendRoutes";
// import Avatar from "primevue/avatar"

export default defineComponent({
  name: "Header",
  components: {
    Menubar,
    Button,
    // Avatar
  },
  data() {
    return {
      authStore: useAuthStore(),
      themeStore: useThemeStore(),
      logoDark: process.env.VUE_APP_LOGO_DARK,
      logoLight: process.env.VUE_APP_LOGO_LIGHT,
    }
  },
  computed: {
    // getLabel(){
    //   if(this.authStore.getUser && this.authStore.getUser.firstname && this.authStore.getUser.name){
    //     return this.authStore.getUser.firstname.charAt(0).toUpperCase() + this.authStore.getUser.name.charAt(0).toUpperCase()
    //   }else if(this.authStore.getUser && this.authStore.getUser.email){
    //     return this.authStore.getUser.email.charAt(0).toUpperCase()
    //   }else{
    //     return ''
    //   }
    // }
    isImpersonating() {
      return localStorage.getItem('isImpersonating') === 'true' && this.authStore.isLoggedIn
    }
  },
  methods: {
    async impersonateRollback(){
      let errorCheck = false
      await fetchWrapper.post(backendRoutes.impersonate_rollback).catch((error) => {
        errorCheck = true
        this.$toast.add({severity: 'error', summary: this.$t('global_components.page_with_left_menu.messages.error_title'), detail: error, life: 5000})
      })

      if(!errorCheck) {
        // this.$toast.add({
        //   severity: 'success',
        //   summary: this.$t('global_components.page_with_left_menu.messages.success_title'),
        //   detail: this.$t('global_components.page_with_left_menu.messages.impersonate_rollback_success_content'),
        //   life: 5000
        // })

        localStorage.removeItem('isImpersonating')
        this.authStore.loadUser()
        this.$router.push({name: 'contact_person_managed_students'})
      }
    }
  },
  emits: ['toggleMenu']
});
</script>

<template>
  <Menubar>
    <template #start>
      <Button text icon="pi pi-bars" severity="secondary" @click="$emit('toggleMenu')" />
      <img v-if="logoDark && themeStore.getTheme === 'dark'" :src="logoDark" alt="logo"/>
      <img v-else-if="logoLight && themeStore.getTheme === 'light'" :src="logoLight" alt="logo"/>
      <span v-else>{{ $t('app.name') }}</span>
    </template>
    <template #end>
<!--      <Avatar :label="getLabel" shape="circle" />-->
      <div v-if="isImpersonating" class="impersonating_header">
        <Button @click="impersonateRollback" icon="pi pi-fw pi-sign-in" :label="$t('global_components.page_with_left_menu.view.impersonate_rollback_button')" size="small" severity="secondary" />
      </div>
    </template>
  </Menubar>
</template>

<style scoped lang="scss">
img{
  height: 2.2rem;
  margin: 0.2rem;
}
</style>
